<template>
    <flex-container
        class="assistent-report-view"
        :gap="null"
    >
        <flex-container
            align-items="center"
            justify-content="space-between"
        >
            <flex-container
                size="auto"
                align-items="center"
            >
                <back-button
                    :to="{ name: 'assistent-dashboard' }"
                />
                <text-decorator
                    :size="'lg'"
                    weight="bold"
                >
                    Inzichten
                </text-decorator>
            </flex-container>
            <flex-container
                v-if="false"
                size="auto"
            >
                <button-block>
                    Exporteer CSV
                </button-block>

                <button-block>
                    Download PDF
                </button-block>
            </flex-container>
        </flex-container>

        <horizontal-line />

        <flex-container>
            <img
                src="@/ai/assistent/assets/report.png"
                alt="Report"
                style="width: 100%; height: auto;"
            />
        </flex-container>
    </flex-container>

    <confirmation-dialog
        ref="placeholderDialog"
        description=""
        label=""
    >
        <template #default>
            <flex-container>
                <flex-container
                    direction="column"
                    align-items="center"
                    align-content="center"
                >
                    <svg-icon
                        :icon="HourglassClock"
                        :size="'lg'"
                        :color="'raspberry-pink-500'"
                        is-custom-icon
                    />

                    <text-heading>
                        We zijn bezig met jouw inzichten!
                    </text-heading>

                    <text-description>
                        <span>
                            Op dit moment verzamelen we data om een eerste rapportage op te stellen. Je
                            kunt het eerste resultaat binnen
                        </span>
                        <text-decorator bold>
                            4 weken
                        </text-decorator>
                        <span>
                            verwachten.
                        </span>
                    </text-description>
                </flex-container>
                <flex-container
                    justify-content="center"
                >
                    <button-block
                        without-loading
                        @click="$router.push({ name: 'assistent-dashboard' })"
                    >
                        <svg-icon
                            :icon="ChevronLeft"
                            :size="'xxs'"
                            is-custom-icon
                        />
                        Terug
                    </button-block>
                </flex-container>
            </flex-container>
        </template>
    </confirmation-dialog>
</template>

<script setup lang="ts">
    import { onMounted, ref } from 'vue';
    import type { ExposedOverlay } from '@keyvue/one-ui';
    import BackButton from '@/shared/components/BackButton.vue';
    import HourglassClock from '@keyvue/one-awesome-icons/icons/regular/hourglass-clock.svg?component';
    import ChevronLeft from '@keyvue/one-awesome-icons/icons/regular/chevron-left.svg?component';

    const placeholderDialog = ref<ExposedOverlay>();

    onMounted(() => {
        placeholderDialog.value?.openOverlay();
    });
</script>

<style scoped lang="scss">
    .chat-interaction-list {
        overflow: hidden;
    }
</style>
